module.exports = __webpack_public_path__ + "static/img/solution_2_05.4574305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution_2_05.png
// module id = jACf
// module chunks = 4